import { RESOURCE_CORE_FIELD_ICONS } from 'v5/patterns/resource/resourceFieldIcons';
import { FilterStringConfig } from 'v5/patterns/filters/FilterWidget.types';

export function createSocialsFilterConfig(): FilterStringConfig {
  return {
    label: 'Socials',
    icon: <RESOURCE_CORE_FIELD_ICONS.socials className="size-4" />,
    type: 'string',
    createDefaultValue: () => ({ operator: 'equals', value: '' }),
    options: {
      placeholder: 'Search by social platform'
    }
  };
}
